import { useContext, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import RewampAppBar from "../rewamp/components/RewampAppBar";
import { RewampFooter } from "../rewamp/components/RewampFooter";
import isStandalone from "../Utils/isStandalone";
import { AppLayoutContext } from "../contexts/AppLayoutContext";
import generateRewampTheme from "../rewamp/rewampTheme";

/**
 * DefaultLayout — legacy-themed page bodies wearing the new RewampAppBar +
 * RewampFooter as chrome.
 *
 * The Outlet stays under the outer App.js theme, so legacy pages render
 * exactly as before. Only the AppBar and Footer are wrapped in the rewamp
 * ThemeProvider so their `primary.main` / `background.white` / Noto Sans
 * tokens resolve to the Bihar Krishi palette.
 */
export default function DefaultLayout() {
  const {
    handleLogout,
    decreaseFontSize,
    increaseFontSize,
    resetTextSize,
    ourTheme,
    initData,
    fontSize,
  } = useContext(AppLayoutContext);

  const isMdUp = useMediaQuery(useTheme().breakpoints.up("md"));

  const rewampTheme = useMemo(
    () => generateRewampTheme(fontSize, ourTheme),
    [fontSize, ourTheme]
  );

  return (
    <>
      <ThemeProvider theme={rewampTheme}>
        <RewampAppBar
          handleLogout={handleLogout}
          decreaseFontSize={decreaseFontSize}
          increaseFontSize={increaseFontSize}
          ourTheme={ourTheme}
          resetTextSize={resetTextSize}
        />
      </ThemeProvider>
      <main className={`app-body ${isMdUp ? "app-body-md" : ""}`} id="main-portal">
        <Outlet />
      </main>
      {!isStandalone() && (
        <ThemeProvider theme={rewampTheme}>
          <RewampFooter initData={initData} />
        </ThemeProvider>
      )}
    </>
  );
}
